import React, { useState, useEffect } from "react";
import ReactDOM from 'react-dom';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import styles from "./TasksTab.module.scss";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefTasksDashboard from "table-defs/TableDefTasksDashboard";
import Button from "components/Button/Button";
import { loadUsersAction, loadSitesAction, loadTasksForUserAction, completeTaskAction } from "store/actions/Actions";
import ViewAssignedTaskModal from "./ViewAssignedTaskModal/ViewAssignedTaskModal";
import QuestionModal from "./QuestionModal/QuestionModal";

const TasksTab = props => {
    const [state, setState] = useState([]);
    const {
        loadTasksForUserAction,
        completeTaskAction,
        isAdmin,
        UserOrgSiteReducer,
        SitesReducer,
        loadSitesAction,
        TasksForUserReducer,
        AuthReducer,
        id,
    } = props;

    const [tasks, setTasks] = useState([]);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showQuestionModal, setShowQuestionModal] = useState(false);

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (id && TasksForUserReducer.tasks) {
            let tasks = TasksForUserReducer.tasks.filter(task => task.id == id);
            if (tasks && tasks.length === 1){
                const task = tasks[0];
                if (task.subTask && task.subTask.audit_response && task.subTask.audit_response.length > 0) {
                    const question = { ...task.subTask.audit_response[0], isComplete: task.completed };
                    setShowQuestionModal(question);
                } else {
                    setShowViewModal(task);
                }
            }
        }
    }, [id, TasksForUserReducer.tasks]);

    useEffect(() => {
        if (!TasksForUserReducer.tasks) {
            loadTasksForUserAction();
        }
    }, [TasksForUserReducer.tasks, loadTasksForUserAction]);

    useEffect(() => {
        if (TasksForUserReducer.tasks && AuthReducer.userData.id) {
            const t = TasksForUserReducer.tasks.filter(t => t.user_id === AuthReducer.userData.id);
            setTasks(t);
        }
    }, [TasksForUserReducer.tasks, AuthReducer.userData.id]);

    const openTasks = () => props.history.push("/achieve/tasks");

    const onChangeRowSelect = ({ selectedRows }) => {
        if (selectedRows !== state.selectedRows) {
            setState(s => ({ ...s, selectedRows }));
        }
    };

    const handleComplete = (selectedTaskIds) => {
        const payload = selectedTaskIds.map(item => {
           return { ...item, completed: true }
        });
        completeTaskAction(payload);
    };

    const handleIncomplete = (selectedTaskIds) => {
        const payload = selectedTaskIds.map(item => {
           return { ...item, completed: false }
        });
        completeTaskAction(payload);
    };

    const renderModal = () => {
        window.scrollTo({ top:0, behavior:"smooth" });
        return ReactDOM.createPortal(
            <ViewAssignedTaskModal
                data={showViewModal}
                setShowModal={setShowViewModal}
            />,
            document.getElementById('modal-root'),
        );
    };
    
    const renderQuestionModal = () => {
        window.scrollTo({ top:0, behavior:"smooth" });
        return ReactDOM.createPortal(
            <QuestionModal
                data={showQuestionModal}
                setShowModal={setShowQuestionModal}
            />,
            document.getElementById('modal-root'),
        );
    };

    const is_admin = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin) ? true : false;
    const is_officer = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_officer) || false;
    const is_super = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_super) || false;

    return (
        <div className={styles["tab-tasks"]}>
            <div className={styles["header"]}>
                <h3>Assigned Tasks</h3>

                {showViewModal && renderModal()}
                {showQuestionModal && renderQuestionModal()}

                {isAdmin && <Button
                    onClick={openTasks}
                    className={styles.button}
                    text="GO TO TASKS"
                    iconEnd={`fal fa-long-arrow-right ${
                        styles["button-arrow"]
                    }`}
                />}
            </div>
                
            <FullDataTable
                className="data-table-tasks-dashboard"
                rowsData={tasks}
                definitions={TableDefTasksDashboard}
                onRowClick={function(e) {
                    if (
                        e.currentTarget.classList.contains("col-actions") ||
                        e.currentTarget.classList.contains("col-row-selector")
                    ) {
                        return;
                    }
                    try {
                        const task = TasksForUserReducer.tasks && TasksForUserReducer.tasks.filter(task => task.id === this.props.rowData.id)[0];
                        if (task.subTask && task.subTask.audit_response && task.subTask.audit_response.length > 0) {
                            const question = { ...task.subTask.audit_response[0], isComplete: task.completed };
                            setShowQuestionModal(question);
                        } else {
                            setShowViewModal(task);
                        }
                    } catch (error) {
                        console.log('error with modal', error);
                    }
                }}
                onChangeRowSelect={({ selectedRows }) =>
                    onChangeRowSelect({ selectedRows })
                }
                customTableProps={
                    (is_officer || is_super || is_admin) ? {
                        selectedRows: state.selectedRows,
                        handleComplete: item => handleComplete([{ id: item.id }]),
                        handleIncomplete: is_super ? item => handleIncomplete([{ id: item.id }]) : undefined,
                    } : {
                        selectedRows: state.selectedRows,
                    }
                }
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    TasksForUserReducer: state.TasksForUserReducer,
    UsersReducer: state.UsersReducer,
    SitesReducer: state.SitesReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
    AuthReducer: state.AuthReducer,
});

const mapDispatchToProps = {
    loadTasksForUserAction,
    loadUsersAction,
    loadSitesAction,
    completeTaskAction
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(TasksTab)
);
